export const toggleActiveClick = () => {
  const triggers = document.querySelectorAll('.js-active-click');
  if (triggers.length < 1) return;

  [...triggers].forEach(trigger => {
    trigger.addEventListener('click', e => {
      e.preventDefault();
      trigger.classList.toggle('active');
    });
  });
};


// WEBPACK FOOTER //
// ./src/js/modules/Click.js